export default [
  {
    path: '/real-estate-developments/:id/blueprints/new',
    name: 'RealEstateDevelopmentsBlueprintsCreate',
    meta: { requiresAuth: true },
    component: () => import('pages/real-estate-developments/tabs/blueprints/BlueprintsForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/blueprints/:id/edit',
    name: 'RealEstateDevelopmentsBlueprintsEdit',
    meta: { requiresAuth: true },
    component: () => import('pages/real-estate-developments/tabs/blueprints/BlueprintsForm.vue')
  }
]
